// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--2aOVe","label":"_93444fe79c--label--2zW8J","content":"_93444fe79c--content--3USoS"};